import { dynamicManager } from 'pages/FormProcess/DynamicForm/DynamicManager';
import { useEffect } from 'react';

const INTERVAL_TIME = 10000; //10 seconds

export const useFetchComments = () => {
  useEffect(() => {
    if (!dynamicManager.canShowCommentBadge()) {
      return;
    }

    let interval = setInterval(() => {
      dynamicManager.getDynamicFormComments('', true);
    }, INTERVAL_TIME);

    return () => {
      interval && clearInterval(interval);
    };
  }, []);
};
